import { AnyAction } from "redux";
import { ThunkAction } from "redux-thunk";
import { VERIFICATION_TARGET } from "../../../../../constants";
import { RootState } from "../../../../../models";
import * as Ajax from "../../../app/Ajax";
import { API_URL_SEND_CODE_ESIM, API_URL_VERIFY_CODE_ESIM } from "../../../esim/api";
import { ESIM_VERIFY_CODE } from "../../../esim/state/actionTypes";
import { VerificationDeliveryMethod } from "../../consts";
import * as AT from "../actionTypes";

export const sendCodeEsim =
    (
        phoneNumber: string,
        deliveryMethod: VerificationDeliveryMethod,
    ): ThunkAction<void, RootState, unknown, AnyAction> =>
    (dispatch) => {
        const onlyDigits = (phoneNumber || "").replace(/\s/g, "");
        dispatch({
            type: AT.CHECKOUT_SEND_CODE,
            payload: Ajax.post(
                {
                    url: API_URL_SEND_CODE_ESIM,
                    data: {
                        phoneNumber: onlyDigits,
                        target: VERIFICATION_TARGET.ESIM_INSTALLMENT_B2B,
                        deliveryMethod,
                    },
                },
                dispatch,
            ),
        });
    };

export const verifyCodeEsim =
    (pin: string, phoneNumber: string): ThunkAction<void, RootState, unknown, AnyAction> =>
    (dispatch) => {
        dispatch({
            type: ESIM_VERIFY_CODE,
            meta: {
                flashOnError: true,
                target: VERIFICATION_TARGET.ESIM_INSTALLMENT_B2B,
            },
            payload: Ajax.post(
                {
                    url: API_URL_VERIFY_CODE_ESIM,
                    data: { pin, phoneNumber, target: VERIFICATION_TARGET.ESIM_INSTALLMENT_B2B },
                },
                dispatch,
            ),
        });
    };
